const PRECISION = 1e18;
export const multiplyWeiAmount = (val1, val2) => {
    return val1 * BigInt(PRECISION * val2) / BigInt(PRECISION);
};
